import { CmsComponent } from '../../model/cms.model';
import { ContentSlotData } from './content-slot-data.model';

export interface Page {
  pageId?: string;
  name?: string;
  description?: string;
  type?: string;
  title?: string;
  template?: string;
  loadTime?: number;
  slots?: { [key: string]: ContentSlotData };
  properties?: any;
  label?: string;

  /**
   * Информация о роботах для поисковых систем: INDEX, NOINDEX, FOLLOW, NOFOLLOW.
   * Определяет будет ли страница индексирована и будут ли следовать ссылки.
   */
  robots?: PageRobotsMeta[];
}

/**
 * Представляет структуру CMS для страниц, слотов и компонентов.
 */
export interface CmsStructureModel {
  page?: Page;
  components?: CmsComponent[];
}

/**
 * Представляет метаданные страницы для формирования SEO информации и разрешения данных страницы.
 */
export interface PageMeta {
  /**
   * Заголовок страницы для тега <title>.
   * Отображается в навигации браузера и в результатах поиска.
   */
  title?: string;

  /**
   * OpenGraph заголовок для мета-тега og:title.
   */
  ogTitle?: string;

  /**
   * Подзаголовок страницы, обычно отображается в пользовательском интерфейсе (H1).
   */
  heading?: string;

  /**
   * Описание страницы для мета-тега description.
   * Используется в результатах поиска.
   */
  description?: string;

  /**
   * OpenGraph описание для мета-тега og:description.
   */
  ogDescription?: string;

  /**
   * Информация о роботах для поисковых систем: INDEX, NOINDEX, FOLLOW, NOFOLLOW.
   * Определяет индексацию и следование по ссылкам на странице.
   */
  robots?: PageRobotsMeta[];

  /**
   * Основное изображение страницы для мета-тега og:image.
   */
  image?: string;

  /**
   * Список хлебных крошек для отображения навигации в пользовательском интерфейсе.
   */
  breadcrumbs?: BreadcrumbMeta[];

  /**
   * Канонический URL для избежания индексации дублей поисковыми системами.
   */
  canonicalUrl?: string;

  /**
   * Тип страницы для разметки OpenGraph (product, website, article и т.д.).
   */
  type?: string;
}

export interface BreadcrumbMeta {
  label: string;
  link: string;
}

export enum PageRobotsMeta {
  INDEX = 'INDEX',
  NOINDEX = 'NOINDEX',
  FOLLOW = 'FOLLOW',
  NOFOLLOW = 'NOFOLLOW',
}
